import styled from 'styled-components';
import { Row } from 'antd';
import { H5, Normal, Medium, Large } from 'components/Core/Typography';

const SpeakerCarousel = styled.div`
  padding: 65px 28px 95px;
  background: var(--blue-fourth);

  .webinar-speakers--container {
    max-width: 1186px;
    margin: 0 auto;
    .webinar-speakers--title {
      margin-bottom: 20px;

      @media (max-width: 992px) {
        text-align: center;
      }
    }
    .webinar-speakers--left-content {
      align-items: center;
      flex-direction: column;
      text-align: center;
      display: flex;
      justify-content: center;

      .speaker-job-role {
        font-size: 16px;
        color: var(--neutral-7);
        margin: 5px 0 0;
      }

      .speaker-job-title {
        color: var(--normal-description-color);
        font-size: 14px;
        font-weight: normal;
        margin: 5px 0 0;
      }
    }
    .slick-arrow {
      @media (max-width: 576px) {
        display: none !important;
      }
    }
    .slick-dots {
      bottom: -45px;

      li {
        margin: 0 1px;

        button:before {
          font-size: 13px;
          color: #c4c4c4;
          opacity: 1;
        }

        &.slick-active button:before {
          color: var(--blue-primary);
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 65px 30px 95px;
  }

  @media (max-width: 576px) {
    padding: 45px 20px 75px;
  }
`;

const SpeakerImage = styled.div`
  height: 200px;
  width: 200px;
  max-width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  @media (max-width: 992px) {
    height: 150px;
    width: 150px;
  }
`;

const Bio = styled(Normal)`
  color: var(--black-color);
  padding-left: 16px;

  p {
    font-size: 16px;
  }

  @media (max-width: 992px) {
    margin-top: 30px;
    padding-left: 0;
  }
`;

const InnerContainer = styled(Row)`
  display: flex !important;
  margin: 0 !important;

  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

export { Bio, InnerContainer, SpeakerCarousel, SpeakerImage };
